import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-code-snippet',
  templateUrl: './code-snippet.component.html',
  styleUrls: ['./code-snippet.component.scss']
})
export class CodeSnippetComponent implements OnInit {
  @Input() data;

  code: string = '';

  ngOnInit(): void {
    this.data.map(d => {
      this.code += d.snippet;
    });
  }
}
